<template>
  <div class="box online_bg" style="margin-top: 0;">
    <div class="wrap w1200">
      <!--左侧分类-->
      <div class="col_1 w246 online_left">
        <a @click="searchByFilter('', null, null, $event)">全部</a>
        <a v-for="item in trees" v-bind:key="item.id" @click="searchByFilter(item.id, null, null, $event, null)">{{item.name}}</a>
      </div>
      <!--/左侧分类-->
      <!--右侧列表-->
      <div class="col_2 w934">
        <!--筛选-->
        <div class="wrap  online_cat">
          <dl>
            <dt>课程分类：</dt>
            <dd>
              <a @click="searchByFilter('', null, null, $event)" class="focus">全部</a>
              <a v-for="item in trees" v-bind:key="item.id" active-class="focus" @click="searchByFilter(item.id, null, null, $event, null)">{{item.name}}</a>
            </dd>
          </dl>
          <div class="clear"></div>
          <dl class="mt10">
            <dt>热门讲师：</dt>
            <dd>
              <a @click="searchByFilter(null, '', null, $event)" class="focus">全部</a>
              <a v-for="item in teacherList" v-bind:key="item.id" active-class="focus" @click="searchByFilter(null, item.id, null, $event, null)">{{item.name}}</a>
            </dd>
          </dl>
          <div class="clear"></div>
          <p><a href="javascript:void(0);" class="focus" @click="searchByFilter(null, null, null, $event, '')">按创建时间</a><a @click="searchByFilter(null, null, null, $event, 'learn_count desc')" href="javascript:void(0);">按学习人数</a></p>
        </div>
        <!--/筛选-->
        <div class="onlinelist" style="min-height: 800px;">
          <h5 class="none_ts" v-if="!courseList" style="text-align: center;">
            <img src="@/assets/images/none_data.jpg" alt="">
            <h4>暂无课程</h4>
          </h5>
          <a v-for="item in courseList" v-bind:key="item.id" @click="course_detail(item.id)">
            <dl>
              <dt>
                <img v-if="!item.faceUrl" src="@/assets/images/zy_default.png" :title="item.name" />
                <img v-if="item.faceUrl" :src="item.faceUrl" :title="item.name" />
                <span class="price_r" v-if="item.coursePriceList[0].price && item.coursePriceList[0].price != '0'">￥{{item.coursePriceList[0].price}}</span>
                <span class="price_r" v-if="!item.coursePriceList[0].price || item.coursePriceList[0].price == '0'">免费</span>
                <span class="man_num_r">{{item.learnCount}}</span>
              </dt>
              <dd>
                <h3 class="single_ellipsis">{{item.name}}</h3>
                <p v-if="item.teacherList && item.teacherList.length>0">讲师：{{item.teacherList[0].teacherName}}<span v-if="item.teacherList.length>1">等</span></p>
                <p v-if="!item.teacherList">讲师：暂无</p>
              </dd>
            </dl>
          </a>
        </div>
        <div class="onsite_list_bottom mtf30">
          <div v-if="cntData > 0">共<b>{{cntData}}</b>门课程</div>
          <div v-if="cntData > 0">
            <paginate :click-handler="clickCallback" :page-count=pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </div>
        </div>
      </div>
      <!--/右侧列表-->
      <div class="clear"></div>

    </div>

  </div>
</template>

<script>

  import Paginate from 'vuejs-paginate'
    export default {
      components: { Paginate },
      data () {
        return {
          filter: {
            pageNo: 1,
            pageSize: 9,
            delFlag: '0',
            courseClassifiId: '',
            courseOrTeacherName: '',
            teacherIds: []
          },
          courseList: [],
          trees: [],
          teacherList: [],
          pages: 0,
          cntData: ''
        }
      },
      created () {
        this.getCourses(this.filter)
        this.getCourseClassification()
        this.getTeachers()
      },
      methods: {
        clickCallback (pageNum) {
          this.filter.pageNo = pageNum
          this.getCourses(this.filter)
        },
        getCourseClassification () {
          this.$api.post(this.$global.courseApiPath, '/course/classification/list', {}, r => {
            this.trees = r.data
          })
        },
        getTeachers () {
          this.$api.post(this.$global.teacherApiPath, '/teacher/teachers', {delFlag: '0'}, r => {
            if (r.data && r.data.length>0) {
              this.teacherList = r.data
            }
          })
        },
        searchByFilter (classificationId, teacherId, courseOrTeacherName, event, orderBy) {
          this.currentPage = 1
          this.filter.pageNo = 1
          if (event != null) {
            $(event.target).siblings('a').removeClass("focus")
            $(event.target).addClass('focus')
          }
          if (classificationId != null) {
            this.filter.courseClassifiId = classificationId
          }
          if (teacherId != null) {
            this.filter.teacherIds = []
            if (teacherId != '') {
              this.filter.teacherIds.push(teacherId)
            }
          }
          if (courseOrTeacherName != null) {
            this.filter.courseOrTeacherName = courseOrTeacherName
          }
          if (orderBy != null) {
            this.filter.orderBy = orderBy
          }
          this.getCourses(this.filter)
        },
        searchByKeyFs (orderBy, event) {
          this.currentPage = 1
          this.filter.pageNo = 1
          if (event != null) {
            $(event.target).siblings('a').removeClass("focus")
            $(event.target).addClass('focus')
          }
          if (orderBy != null) {
            this.filter.orderBy = orderBy
          }
          this.$api.post(this.$global.courseApiPath, '/course/courses/teacher/page', this.filter, r => {
            if (r.data && r.data.length>0) {
              this.courseList = r.data
            } else {
              this.courseList = r.data
            }
            this.cntData = r.cntData
            this.pages = Math.ceil(r.cntData / this.filter.pageSize)
          })
        },
        getCourses (filter) {
          this.$api.post(this.$global.bylApiPath, '/studyItemScopes/findCourseList', filter, r => {
            if (r.data && r.data.length>0) {
              this.courseList = r.data
            } else {
              this.courseList = r.data
            }
            this.cntData = r.cntData
            this.pages = r.cntData / this.filter.pageSize
          })
        },
        course_detail (id) {
          this.$router.push({path: '/continueEdu/courseDetail/'+ id})
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/continueEdu/course/list.vue